<ng-container *transloco="let t">
  <div class="mb-3 flex items-center">
    <app-strategy-dropdown
      class="start-dropdown"
      [strategies]="strategies"
      (selectedStrategy)="setStrategy($event)"
    ></app-strategy-dropdown>

    <ICheckbox
      class="ml-4"
      label="{{ t('hourly-chart.include_not_operated_campaign') }}"
      [value]="includeNonM19Campaign"
      (valueChange)="toggleIncludeNonM19Campaign($event)"
    />
  </div>
  <div>
    <app-metric-selector
      [data]="globalData"
      (chartMetricsChanges)="selectMetrics($event)"
      [pageMetrics]="$any(CHART_METRICS)"
      [localStorageKey]="localStorageKey"
      [showCompare]="false"
    ></app-metric-selector>
  </div>

  @if (chartDisplayed) {
    <chart-layout closable (close)="toggleChartDisplay(false)">
      <div class="flex h-full w-full flex-col gap-1">
        <canvas
          baseChart
          class="chart"
          [datasets]="dataSet.chartDataSet"
          type="line"
          [labels]="dataSet.labels"
          [options]="dataSet.lineChartOptions"
          #canvas
        >
        </canvas>

        <div class="mt-3 flex justify-end">
          <div class="text-xs text-gray-500">
            <div>{{ t("hourly-chart.hourly_display") }}</div>
            @if (timeZone) {
              <div>
                {{ t("hourly-chart.hours_displayed", [getTimezone(), getTimezonUtcOffset()]) }}
              </div>
            }
          </div>
        </div>
      </div>
    </chart-layout>
  }
</ng-container>
